import { getKlinecharts, klinecharts } from "../../klinecharts-client";

export { getKlinecharts };

export function safeRegisterOverlay(def: Record<string, unknown>) {
  if (typeof window === "undefined" || !klinecharts) return;
  try {
    klinecharts.registerOverlay(def);
  } catch {
    // overlay may already be registered
  }
}
